module.exports = __webpack_public_path__ + "img/recorte-direita@2x.3f663a8c.png";